import { markRaw, reactive } from 'vue';
import { TooltipContent, TooltipInfo, TooltipTheme } from '../models/TooltipInfo';

class TooltipService {
  private enabled = true;
  private current: TooltipInfo | null = null;

  getCurrent(): TooltipInfo | null {
    return this.current;
  }

  show(content: TooltipContent, target: HTMLElement, theme: TooltipTheme): void {
    if (!this.enabled) return;
    this.current = markRaw({ ...content, target, theme });
  }

  hide(): void {
    this.current = null;
  }

  enable(): void {
    this.enabled = true;
  }

  disable(): void {
    this.enabled = false;
    this.current = null;
  }
}

export default reactive(new TooltipService());